/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Table, Spin, DatePicker, Select, message, Col, Button } from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import { dateFormat_dmy } from "../../../utils";
import constants from "../../../constants/constants";
import { DownloadOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { DRS_REPORT } = urls;
const { ROLES } = constants;
const { CP_ADMIN } = ROLES;

const DeliveryMISReport = () => {
  const navigate = useCustomNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [dateRange, setDateRange] = useState(() => {
    // Try to restore date range from localStorage
    const savedDateRange = localStorage.getItem("drsReportDateRange");
    if (savedDateRange) {
      try {
        const parsed = JSON.parse(savedDateRange);
        return {
          startDate: parsed.startDate
            ? moment(parsed.startDate)
            : moment(new Date(), dateFormat_dmy),
          endDate: parsed.endDate
            ? moment(parsed.endDate)
            : moment(new Date(), dateFormat_dmy),
        };
      } catch (error) {
        console.error("Error parsing saved date range:", error);
      }
    }
    // Default to today's date
    return {
      startDate: moment(new Date(), dateFormat_dmy),
      endDate: moment(new Date(), dateFormat_dmy),
    };
  });
  const [selectedHubId, setSelectedHubId] = useState(undefined);
  const [selectedCpId, setSelectedCpId] = useState(undefined);

  useEffect(() => {
    const initialSpId =
      JSON.parse(localStorage.getItem("userinfo"))?.spId || null;
    const initialPremiseId =
      JSON.parse(localStorage.getItem("userinfo"))?.premiseId || null;
    setSelectedCpId(initialSpId);
    setSelectedHubId(initialPremiseId);
  }, []);

  useEffect(() => {
    if (selectedCpId === undefined || selectedHubId === undefined) {
      return;
    }
    fetchReportData(pageNum, pageSize);
  }, [selectedCpId, selectedHubId, dateRange, pageNum, pageSize]);

  const buildQueryParams = (page, limit) => {
    const queryParams = new URLSearchParams();
    const userinfo = JSON.parse(localStorage.getItem("userinfo"));
    const isCpAdmin =
      userinfo && userinfo.roles && userinfo.roles.includes(CP_ADMIN);

    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());

    if (dateRange.startDate) {
      queryParams.append(
        "startDate",
        moment(dateRange.startDate).format("YYYY-MM-DD")
      );
    }
    if (dateRange.endDate) {
      queryParams.append(
        "endDate",
        moment(dateRange.endDate).format("YYYY-MM-DD")
      );
    }
    if (selectedCpId) {
      queryParams.append("cpId", selectedCpId);
    }
    // Exclude hubId for CP admin role
    if (selectedHubId && !isCpAdmin) {
      queryParams.append("hubId", selectedHubId);
    }
    return queryParams;
  };

  const fetchReportData = async (currentPage, currentLimit) => {
    setLoading(true);
    const queryParams = buildQueryParams(currentPage, currentLimit);
    try {
      const result = await API.Api(
        `${DRS_REPORT}?${queryParams.toString()}`
      ).getwithParams({}, { kid: "1", authtype: "jwt" });
      const response = result?.response?.data;
      if (response && response.data) {
        const drsData = response?.data || [];
        setTotal(response.totalCount || drsData.length);
        setTableData(drsData);
      } else {
        setTableData([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching DRS report:", error);
      setTableData([]);
      setTotal(0);
    }
    setLoading(false);
  };

  // Function to handle column click - navigate to AWB Details page
  const handleColumnClick = (record, key, value) => {
    if (value > 0) {
      // Save current date range before navigation
      try {
        localStorage.setItem(
          "drsReportDateRange",
          JSON.stringify({
            startDate: dateRange.startDate
              ? dateRange.startDate.format("YYYY-MM-DD")
              : null,
            endDate: dateRange.endDate
              ? dateRange.endDate.format("YYYY-MM-DD")
              : null,
          })
        );
      } catch (error) {
        console.error("Error saving date range before navigation:", error);
      }

      const queryParams = new URLSearchParams();
      queryParams.append("startDate", moment(record.date).format("YYYY-MM-DD"));
      queryParams.append("endDate", moment(record.date).format("YYYY-MM-DD"));
      queryParams.append("key", key);
      queryParams.append("page", "1");

      navigate(`/delivery-mis-report/report-details?${queryParams.toString()}`);
    }
  };

  const columns = [
    {
      title: "Hub",
      dataIndex: "hubName",
      key: "hubName",
      width: 150,
      render: (text) => text || "N/A",
    },
    {
      title: "CP Name",
      dataIndex: "cpName",
      key: "cpName",
      width: 150,
      render: (text) => text || "N/A",
    },
    {
      title: "Date",
      dataIndex: ["date"],
      key: "date",
      width: 80,
      render: (text, record) => {
        return record?.date
          ? `${moment(record?.date).format("DD-MM-YYYY")}`
          : "N/A";
      },
    },
    {
      title: "Outscan By Hub",
      dataIndex: ["outscanByHub"],
      key: "outscanByHub",
      align: "center",
      width: 80,
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "outscanned", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Inscan By CP",
      dataIndex: ["inscanByCP"],
      key: "inscanByCP",
      align: "center",
      width: 80,
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "inscanned", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Not Inscan By CP",
      dataIndex: ["notInScanByCP"],
      key: "notInScanByCP",
      align: "center",
      width: 80,
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "notInScan", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Pending Previous Day",
      dataIndex: ["pendingPreviousDay"],
      key: "pendingPreviousDay",
      width: 80,
      align: "center",
      render: (text) => text || 0,
    },
    {
      title: "DRS Generation",
      dataIndex: ["drsGenerationByCPOfSameDay"],
      key: "drsGenerationByCPOfSameDay",
      width: 80,
      align: "center",
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() =>
              handleColumnClick(record, "drsGenerationByCPOfSameDay", value)
            }
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Same Day Deliveries",
      dataIndex: "sameDayDeliveries",
      key: "sameDayDeliveries",
      width: 80,
      align: "center",
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "delivered", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Undelivered",
      dataIndex: ["undelivered"],
      key: "undelivered",
      width: 80,
      align: "center",
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "undelivered", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "RTO",
      dataIndex: ["rto"],
      key: "rto",
      width: 80,
      align: "center",
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "rto", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Inscan vs Delivery",
      dataIndex: ["inscanVsDelivery"],
      key: "inscanVsDelivery",
      width: 80,
      align: "center",
      render: (text) => text || 0,
    },
    {
      title: "Total Delivery",
      dataIndex: ["totalDelivery"],
      key: "totalDelivery",
      width: 80,
      align: "center",
      render: (text, record) => {
        const value = text || 0;
        return value > 0 ? (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
            onClick={() => handleColumnClick(record, "totalDelivery", value)}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        );
      },
    },
  ];

  const handlePageChange = (pagination) => {
    const newPageNum = pagination.current;
    const newPageSize = pagination.pageSize;
    setPageNum(newPageNum);
    setPageSize(newPageSize);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const handleDateChange = (dates) => {
    const newStartDate = dates && dates[0] ? dates[0] : null;
    const newEndDate = dates && dates[1] ? dates[1] : null;

    // Validate date range - maximum 30 days
    if (newStartDate && newEndDate) {
      const daysDifference = moment(newEndDate).diff(
        moment(newStartDate),
        "days"
      );
      if (daysDifference > 30) {
        message.error(
          "Date range cannot exceed 30 days. Please select a shorter date range."
        );
        return;
      }
    }

    const newDateRange = { startDate: newStartDate, endDate: newEndDate };
    setDateRange(newDateRange);

    // Save date range to localStorage
    try {
      localStorage.setItem(
        "drsReportDateRange",
        JSON.stringify({
          startDate: newStartDate ? newStartDate.format("YYYY-MM-DD") : null,
          endDate: newEndDate ? newEndDate.format("YYYY-MM-DD") : null,
        })
      );
    } catch (error) {
      console.error("Error saving date range to localStorage:", error);
    }

    setPageNum(1);
  };

  const handleHubChange = (value) => {
    setSelectedHubId(value);
    setPageNum(1);
  };

  const handleCpChange = (value) => {
    setSelectedCpId(value);
    setPageNum(1);
  };

  const disabledDate = (current) => {
    // Disable dates after today
    return current && current > moment().endOf("day");
  };

  const handleDownloadReport = async () => {
    if (!dateRange.startDate || !dateRange.endDate) {
      message.error("Please select a date range for export");
      return;
    }

    setLoading(true);
    try {
      const userinfo = JSON.parse(localStorage.getItem("userinfo"));
      const isCpAdmin =
        userinfo && userinfo.roles && userinfo.roles.includes(CP_ADMIN);

      const params = {
        startDate: dateRange.startDate.toISOString().split("T")[0],
        endDate: dateRange.endDate.toISOString().split("T")[0],
        page: pageNum,
        limit: 50,
        ...(selectedCpId && { cpId: selectedCpId }),
        ...(selectedHubId && !isCpAdmin && { hubId: selectedHubId }),
      };

      await downloadDeliveryMISReport(params);
      message.success("Delivery MIS Report exported successfully");
    } catch (error) {
      console.error("Export error:", error);
      message.error(error?.message || "Failed to export report");
    } finally {
      setLoading(false);
    }
  };

  const downloadDeliveryMISReport = async (params) => {
    const downloadParams = {
      startDate: params.startDate,
      endDate: params.endDate,
      page: params.page,
      limit: params.limit,
      cpId: params.cpId,
      hubId: params.hubId,
    };

    // Clean params - remove null, undefined, and empty string values
    const cleanParams = Object.fromEntries(
      Object.entries(downloadParams).filter(
        ([_, value]) => value != null && value !== ""
      )
    );

    const queryString = new URLSearchParams(cleanParams).toString();
    const fullUrl = `${DRS_REPORT}/download?${queryString}`;
    window.open(fullUrl, "_blank");
  };

  return (
    <Spin spinning={loading}>
      <div className="master-main-container m-1 p-1">
        <div
          className="mb-1"
          style={{
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h1>Delivery MIS Report</h1>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <RangePicker
              value={
                dateRange.startDate && dateRange.endDate
                  ? [dateRange.startDate, dateRange.endDate]
                  : null
              }
              format={dateFormat_dmy}
              onChange={handleDateChange}
              disabledDate={disabledDate}
              className="input-field-style"
              style={{ width: "225px" }}
            />
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={handleDownloadReport}
              disabled={loading || tableData.length === 0}
            >
              Download Report
            </Button>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{
            pageSize: pageSize,
            total: total,
            itemRender: itemRender,
            current: pageNum,
          }}
          onChange={handlePageChange}
          loading={loading}
          scroll={{ x: "max-content" }}
        />
      </div>
    </Spin>
  );
};

export default DeliveryMISReport;
